export default __webpack_public_path__ + "static/media/promo-harry-in-hiding_03.62630610.jpg";